import { render, staticRenderFns } from "./PurchaseInvoice.vue?vue&type=template&id=ec8ddb5e"
import script from "./PurchaseInvoice.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports